/** Company-owned contact and legal links, never a customer's record identity. */

import { PORTAL_BRAND } from '../../config/branding';

export function BrandFooter() {
  if (PORTAL_BRAND.id !== 'geauxfile') return null;
  return (
    <footer
      className="border-t px-4 py-5 text-center text-xs"
      style={{
        borderColor: 'hsl(var(--color-neutral-200))',
        color: 'hsl(var(--color-neutral-600))',
      }}
    >
      <p>{PORTAL_BRAND.legalName}</p>
      <nav
        aria-label="Contact and legal"
        className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-2"
      >
        <a className="hover:underline" href={`mailto:${PORTAL_BRAND.supportEmail}`}>
          {PORTAL_BRAND.supportEmail}
        </a>
        <a
          className="hover:underline"
          href={`tel:${PORTAL_BRAND.supportPhone.replace(/[^\d+]/g, '')}`}
        >
          {PORTAL_BRAND.supportPhone}
        </a>
        <a
          className="hover:underline"
          href={PORTAL_BRAND.termsUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
        <a
          className="hover:underline"
          href={PORTAL_BRAND.privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
        {PORTAL_BRAND.acceptableUseUrl ? (
          <a
            className="hover:underline"
            href={PORTAL_BRAND.acceptableUseUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Acceptable Use
          </a>
        ) : null}
      </nav>
    </footer>
  );
}
